import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';
import Swiper, {Navigation, Pagination, SwiperOptions} from 'swiper';
import type {NavigationOptions} from 'swiper/types';

import {BBS_CATEGORY, VIDEO_CATEGORY} from '../shared/defines/protocol';
import {Video} from '../shared/models/video.model';
import {VideoService} from '../shared/services/video/video.service';
import {LayoutMgrService} from '../shared/services/layout-mgr/layout-mgr.service';
import {FOOTER_ON} from '../shared/components/footer/footer.component';
import {
  DEFAULT_SCROLL_SPEED,
  findVideoData, HISTORY_KEY_SEARCH_VIDEO,
  LIST_TYPE,
  SearchParam, VideoQueryParams,
} from '../shared/defines/client.const';
import {VideoHistoryService} from '../shared/services/video/video-history.service';
import {VideoBookmarkService} from '../shared/services/video/video-bookmark.service';
import {ScrollDownService} from "../shared/services/scroll-down/scroll-down.service";
import {NormalizeSearchParamKeyword} from '../shared/defines/search-keyword.func';


Swiper.use([Navigation, Pagination]);

type VIDEO_COLLECT = {
  category: VIDEO_CATEGORY;
  videoCollect: Array<Video>;
};


@Component({
  selector: 'app-movie-collect',
  templateUrl: './movie-collect.component.html',
  styleUrls: ['./movie-collect.component.scss']
})
export class MovieCollectComponent implements OnInit, OnDestroy {
  @ViewChild('container') container: ElementRef;

  public readonly FooterOn = FOOTER_ON;
  public readonly HistoryKeySearch = HISTORY_KEY_SEARCH_VIDEO;
  protected readonly findVideoData = findVideoData;
  protected readonly VIDEO_CATEGORY = VIDEO_CATEGORY;
  protected readonly BBS_CATEGORY = BBS_CATEGORY;


  config: SwiperOptions = {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 10,
    autoplay: true,
    observeParents: true,
    // loop: true,
    // navigation: {
    //   prevEl: '.screen1 .swiper-button-prev', // 다음 버튼 클래스명
    //   nextEl: '.screen1 .swiper-button-next', // 이번 버튼 클래스명
    // },
  };

  private load$: Subscription = null;
  public get IsLoading(): boolean {
    return this.load$ !== null;
  }

  protected sendingBookmark = false;


  /**
   * 영상 범주 목록
   * TODO: 영상 범주가 급격히 바뀐다면, 범주 정보도 서버에서 받아오도록 수정할 필요가 있다.
   */
  private listVideoCollect: Array<VIDEO_COLLECT> = [
    {
      category: VIDEO_CATEGORY.DIALECT,
      videoCollect: new Array<Video>(),
    },
    {
      category: VIDEO_CATEGORY.COOL_EXPR,
      videoCollect: new Array<Video>(),
    },
    {
      category: VIDEO_CATEGORY.WRONG_EXPR,
      videoCollect: new Array<Video>(),
    },
    {
      category: VIDEO_CATEGORY.PROVERB,
      videoCollect: new Array<Video>(),
    },
    {
      category: VIDEO_CATEGORY.LOAN_WORD,
      videoCollect: new Array<Video>(),
    },
    {
      category: VIDEO_CATEGORY.HOMONYM,
      videoCollect: new Array<Video>(),
    },
  ];

  private findVideoCollect(category: VIDEO_CATEGORY): VIDEO_COLLECT {
    return this.listVideoCollect.find(item => item.category === category);
  }

  public get ListCategory(): Array<VIDEO_COLLECT> {
    return this.listVideoCollect.filter(cat => cat.videoCollect.length > 0);
  }

  // 푸터의 아래로 내리기 버튼 구독
  private scrollDown$: Subscription | null = null;

  constructor(
    private router: Router,
    private videoService: VideoService,
    private historySvc: VideoHistoryService,
    private bmSvc: VideoBookmarkService,
    // private naviSvc: NavigationService,
    private scrollDownSvc: ScrollDownService,
    public lm: LayoutMgrService,
  ) {
    lm.Reset();

    this.load$ = videoService.GetList().pipe(
      finalize(() => this.load$ = null)
    ).subscribe(
      (listVideo: Array<Video>) => {
        console.log('listVideo = ', listVideo);

        listVideo.forEach(video => {
          const collect = this.findVideoCollect(video.category);
          if (collect) {
            collect.videoCollect.push(video);
          }
        });

        console.log('listVideoCollect = ', this.listVideoCollect);
      },
      err => console.error(err));
  }

  ngOnInit(): void {
    // 푸터의 스크롤 버튼 처리.
    this.scrollDown$ = this.scrollDownSvc.pushScrollDown$().subscribe(isFirst => {
      const scrollDelta = DEFAULT_SCROLL_SPEED * (isFirst ? 2 : 1);  // 스크롤 시작할 때 첫번째는 두배로 스크롤 함.

      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + scrollDelta,
        behavior: 'auto',
      });
    });
  }

  ngOnDestroy(): void {
    this.lm.CloseYoutubePopup();

    if (this.load$) {
      this.load$.unsubscribe();
      this.load$ = null;
    }

    this.scrollDownSvc.popScrollDown$();
    if (this.scrollDown$) {
      this.scrollDown$.unsubscribe();
      this.scrollDown$ = null;
    }
  }

  public onGoHistory(): void {
    // console.warn('navigate(/movie-search) - MovieCollectComponent::onGoHistory()');
    const queryParams = {l: LIST_TYPE.HISTORY};
    this.router.navigate(['/movie-search'], {queryParams}).then();
  }

  public ToggleBookmark(video: Video): void {
    if (this.sendingBookmark) {
      return;
    }
    this.sendingBookmark = true;

    video.bookmark = !video.bookmark;
    this.bmSvc.sendBookmark(video.no, video.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => console.log(data),
      err => console.error(err)
    );
  }

  public GetSwiperNavigationTxt(idx: number): NavigationOptions {
    const ret: NavigationOptions = {
      prevEl: `.swiper-${idx} .swiper-button-prev`,
      nextEl: `.swiper-${idx} .swiper-button-next`,
    };
    // console.log('GetSwiperNaviationTxt= ', ret);

    return ret;
  }

  public SearchVideo(param: SearchParam): void {
    // console.log('MovieSearchComponent::ReloadList() param =', param);

    param = NormalizeSearchParamKeyword(param);
    if (param?.keyword) {
      // console.warn('navigate(/movie-search) - MovieCollectComponent::SearchVideo() param =', param);
      const queryParams = {
        ...{keyword: param.keyword},
        l: LIST_TYPE.SERVER,
      };
      this.router.navigate(['/movie-search'], {queryParams}).then();
    }
  }

  protected getRouterLink(cat: VIDEO_COLLECT): string[] {
    return findVideoData(cat.category).routerLink;
  }

  protected getQueryParams(cat: VIDEO_COLLECT): VideoQueryParams | {} {
    return findVideoData(cat.category).queryParams ?? {};
  }
}
